var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddCard = function SvgAddCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "add-card_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m6.333 15.392 11.475 42.823 11.859-3.178V38.999H39v-9.333h7.393L40.14 6.333zm44.334 18.94h-7v9.334h-9.333v7h9.333v9.333h7v-9.333H60v-7h-9.333z",
    clipRule: "evenodd"
  })));
};
export { SvgAddCard as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuMzMzMzcgMTUuMzkyMUwxNy44MDc3IDU4LjIxNDhMMjkuNjY2OSA1NS4wMzdWMzguOTk4OUgzOS4wMDAzVjI5LjY2NTVINDYuMzkyN0w0MC4xNDA4IDYuMzMzMzdMNi4zMzMzNyAxNS4zOTIxWk01MC42NjY5IDM0LjMzMjJINDMuNjY2OVY0My42NjU1SDM0LjMzMzZWNTAuNjY1NUg0My42NjY5VjU5Ljk5ODlINTAuNjY2OVY1MC42NjU1SDYwLjAwMDNWNDMuNjY1NUg1MC42NjY5VjM0LjMzMjJaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";